import React, { useMemo } from 'react';
import { Row, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import FilterSelector from 'components/Flux/Automatic/FilterSelector';
import MLTSelector from 'components/Flux/Automatic/MLTSelector';
import ViewToggler from 'components/Flux/Automatic/Monthly/ViewToggler';
import Graph from 'components/Flux/Automatic/Monthly/Graph';
import Table from 'components/Flux/Automatic/Monthly/Table';
import ActiveFilters from 'components/Flux/Automatic/ActiveFilters';
import RoundInfoPopover from 'components/Flux/Automatic/Daily/RoundInfoPopover';
import Snackbar from 'components/DesignSystem/Snackbar';
import useViewToggler from 'utils/hooks/flux/automatic/viewToggler';
import useMonthlyData from 'utils/hooks/flux/automatic/useMonthlyData';
import usePastSimulationNames from 'utils/hooks/flux/automatic/usePastSimulationNames';
import useFluxAutomaticZipDownload from 'utils/hooks/flux/automatic/useFluxAutomaticZipDownload';
import { buildSubdivisionParam } from 'helper/flux/automatic';
import {
  selectFluxAutomaticControlPanelMltOption,
  selectFluxAutomaticControlPanelSpatialSubdivision,
  selectFluxAutomaticControlPanelAutomaticStudyScenarios,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';

export default function MonthlyDesktop() {
  const { pastSimulationNames } = usePastSimulationNames();
  const unidade = useSelector(selectFluxAutomaticControlPanelMltOption);
  const models = useSelector(selectFluxAutomaticControlPanelAutomaticStudyScenarios);
  const subdivision = useSelector(selectFluxAutomaticControlPanelSpatialSubdivision);
  const {
    showGraph, showTable, toggleGraph, toggleTable,
  } = useViewToggler();
  const {
    data, graphicReadyData, isFetching, rodadas,
  } = useMonthlyData();
  const dataIsEmpty = Object.keys(graphicReadyData).length === 0;
  const spatialSubdivisionParam = useMemo(() => buildSubdivisionParam(subdivision), [subdivision]);
  const { DownloadZipButton, DownloadConfirmationDialog } = useFluxAutomaticZipDownload({
    models,
    unidade,
    type: 'monthly',
    pastSimulationNames,
    spatialSubdivisionParam,
  });

  return (
    <div className="pt-4 px-5">
      <DownloadConfirmationDialog />
      <div className="d-xl-flex flex-row">
        <div className="d-lg-flex flex-row me-auto mb-2">
          <FilterSelector />
          <div className="ms-lg-3 mt-2 mt-lg-0">
            <MLTSelector />
          </div>
        </div>
        <div className="mb-2">
          <ViewToggler
            showGraph={showGraph}
            showTable={showTable}
            toggleGraph={toggleGraph}
            toggleTable={toggleTable}
          />
        </div>
        <div className="mb-2 ms-xl-3 d-flex align-items-center gap-2">
          <RoundInfoPopover scenarioNames={Object.keys(graphicReadyData)} rodadas={rodadas} />
          <DownloadZipButton />
        </div>
      </div>
      <div className="px-0">
        <ActiveFilters />
      </div>
      <Row>
        { isFetching && <div className="text-center py-4"><Spinner /></div> }
        { !isFetching && dataIsEmpty && (
          <Snackbar>
            Nenhum dado para os filtros selecionados.
          </Snackbar>
        )}
        { !isFetching && !dataIsEmpty && showGraph
          && <Graph data={graphicReadyData} formatString="yyyyMM" rodadas={rodadas} /> }
        { !isFetching && !dataIsEmpty && showTable && <Table data={data} /> }
      </Row>
    </div>
  );
}
